<i18n>
{
  "en":{
    "loading": "Loading..."
    
  },
  "zhHant":{
    "loading": "讀取中..."
  },
  "ja":{
    "loading": "読み込み中…"
  },
  "ko":{
    "loading": "불러오는 중…"
  }
}
</i18n>

<template>
  <div :style="{ height: (height || 80) + 'px' }">
    <VueC3 :handler="handler" />
    <div v-if="showLoading">{{ $t('loading') }}</div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueC3 from 'vue-c3';
import * as d3 from 'd3';

export default {
  props: ['data', 'min', 'max', 'step', 'height'],
  components: {
    VueC3,
  },
  data() {
    return {
      showLoading: true,
      chartData: [],
      handler: new Vue(),
      delayId: 0,
    };
  },
  mounted() {
    this.delayRender();
  },
  watch: {
    data: function () {
      this.delayRender();
    },
  },
  methods: {
    delayRender() {
      if (this.delayId !== 0) {
        clearTimeout(this.delayId);
      }
      this.delayId = setTimeout(() => {
        this.delayId = 0;
        this.chartData = this.data;
        this.genChart();
      }, 300 + Math.random() * 1500);
    },
    genChart() {
      const minMax = this.getMinMax(this.chartData);
      const options = {
        size: { height: 80 },
        data: {
          xFormat: '%Y-%m-%d %H:%M:%S',
          columns: this.genColumns(this.chartData),
          type: 'spline',
        },
        tooltip: { show: false },
        legend: { hide: true, position: 'inset' },
        grid: {
          x: {
            show: true,
          },
          y: {
            show: true,
          },
        },
        axis: {
          x: {
            show: true,
            min: 0.5,
            max: 32,
            tick: { values: d3.range(0, 32, 3) },
            padding: { top: 0, bottom: 0, left: 0, right: 0 },
          },
          y: {
            show: true,
            min: this.min || minMax.min,
            max: this.max || minMax.max,
            tick: {
              values: d3.range(this.min || minMax.min, this.max || minMax.max, this.step || minMax.step),
            },
            padding: { top: 5, bottom: 0, left: 0, right: 0 },
          },
        },
      };
      this.showLoading = false;
      this.handler.$emit('init', options);
    },
    genColumns(data) {
      const columns = [['']];
      columns[0].push(data[0]);
      for (let i = 0; i < data.length; i++) {
        columns[0].push(data[i]);
      }
      return columns;
    },
    getMinMax(data, tickNum = 5) {
      if (data.length === 0) {
        return { min: 0, max: 10, step: 2 };
      }
      let min = Number.MAX_VALUE;
      let max = Number.MIN_VALUE;
      for (var i = 0; i < data.length; i++) {
        if (data[i] === 0) {
          continue;
        }
        min = Math.min(min, data[i]);
        max = Math.max(max, data[i]);
      }
      const range = max - min;
      if (Math.abs(range) < 0.0001) {
        return { min: 0, max: 10, step: 2 };
      }
      const log = Math.floor(Math.log10(range));
      const stepBase = Math.pow(10, log);
      return {
        min: Math.floor(min / stepBase) * stepBase,
        max: Math.ceil(max / stepBase) * stepBase,
        step: Math.ceil(range / tickNum / stepBase) * stepBase,
      };
    },
  },
};
</script>

<style></style>
